export default {
  async fetchAutocomplete({ commit, state }) {
    try {
      if (state.string === '') {
        commit('setData', {});
        return;
      }

      if (state.autocompleteSource) {
        state.autocompleteSource.cancel();
      }
      commit('setAutocompleteSource', this.$axios.CancelToken.source());
      const data = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/products/search/autocomplete`,
        {
          cancelToken: state.autocompleteSource.token,
          params: {
            query: state.string,
            categoryIds: state.category,
          },
        },
      );
      commit('setData', data);
    } catch {}
  },
};
